module.exports = __webpack_public_path__ + "img/logo.54a08e58.png";